import i18n from "i18n";
import { createColumns } from "common/helpers/createColumn";

export const columns = createColumns(
  {
    dataField: "reportId",
    text: i18n.t("labelReportNumber"),
  },
  {
    dataField: "createdOn",
    text: i18n.t("reportDate"),
  },
  {
    dataField: "decisionName",
    text: i18n.t("labelDescision"),
  },
  {
    dataField: "offenceName",
    text: i18n.t("offenceTypeName"),
  }
);
